import InviteTeammatesStep from './steps/invite-teammates-step';
import PersonaUseCaseStep from './steps/persona-use-case-step';
import SuggestedWorkspacesStep from './steps/suggested-workspaces-step';
import WorkJobDescriptionStep from './steps/work-job-description-step';
import WorkspaceCreateStep from './steps/workspace-create-step';
import WorkspaceSetupCompositeStep from './steps/workspace-setup-composite-step';
import { DownloadOptionsWithButtons } from './steps/download-options';

// screens
export const PERSONA_USE_CASE_STEP = 'persona-use-case-step';
export const WORK_JOB_DESCRIPTION_STEP = 'work-job-description-step';
export const SUGGESTED_WORKSPACES_STEP = 'suggested-workspaces-step';
export const WORKSPACE_CREATE_STEP = 'workspace-create-step';
export const DOWNLOAD_OPTIONS_STEP = 'download-options-step';
export const WORKSPACE_SETUP_COMPOSITE_STEP = 'workspace-setup-composite-step';

// experimental steps
export const INVITE_TEAMMATES_STEP = 'invite-teammates-step';

export const STEPS = {
  PERSONA_USE_CASE_STEP,
  WORK_JOB_DESCRIPTION_STEP,
  SUGGESTED_WORKSPACES_STEP,
  WORKSPACE_CREATE_STEP,
  DOWNLOAD_OPTIONS_STEP,
  WORKSPACE_SETUP_COMPOSITE_STEP,
  INVITE_TEAMMATES_STEP,
};

export const MAP_SCREEN_STEP_KEY_TO_COMPONENT = {
  [PERSONA_USE_CASE_STEP]: PersonaUseCaseStep,
  [WORKSPACE_CREATE_STEP]: WorkspaceCreateStep,
  [DOWNLOAD_OPTIONS_STEP]: DownloadOptionsWithButtons,
  [WORK_JOB_DESCRIPTION_STEP]: WorkJobDescriptionStep,
  [INVITE_TEAMMATES_STEP]: InviteTeammatesStep,
  [SUGGESTED_WORKSPACES_STEP]: SuggestedWorkspacesStep,
  [WORKSPACE_SETUP_COMPOSITE_STEP]: WorkspaceSetupCompositeStep,
};

export const JOIN_REQUEST_STATES = {
  REQUESTED: 'requested',
  AUTOJOINED: 'autojoined',
  SKIPPED: 'skipped',
};

export const MAP_KEY_TO_STEP = {
  [PERSONA_USE_CASE_STEP]: 0,
  [WORK_JOB_DESCRIPTION_STEP]: 0,
  [WORKSPACE_CREATE_STEP]: 1,
  [SUGGESTED_WORKSPACES_STEP]: 1,
  [WORKSPACE_SETUP_COMPOSITE_STEP]: 1,
  [INVITE_TEAMMATES_STEP]: 2,
  [DOWNLOAD_OPTIONS_STEP]: 3,
};
